// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"478":"d1b01ddd","498":"3448b105","703":"494a5b29"}[chunkId] + ".chunk.js";
};